"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_slick_1 = tslib_1.__importDefault(require("react-slick"));
var mobx_react_1 = require("mobx-react");
var sample_1 = tslib_1.__importDefault(require("lodash/sample"));
var SliderDetails_1 = require("./SliderDetails");
var ClaimForm_1 = require("./ClaimForm");
// import { Quality } from './Quality';
var ProjectsBlock_1 = require("./ProjectsBlock");
var ParnersBlock_1 = require("./ParnersBlock");
var ProductsGrid_1 = require("./ProductsGrid");
var MainPage = /** @class */ (function (_super) {
    tslib_1.__extends(MainPage, _super);
    function MainPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.nextSlide = function () {
            if (_this.sliderComponent) {
                _this.sliderComponent.slickNext();
            }
        };
        _this.previousSlide = function () {
            if (_this.sliderComponent) {
                _this.sliderComponent.slickPrev();
            }
        };
        return _this;
    }
    MainPage.prototype.render = function () {
        var _this = this;
        var _a = this.props.store.data, projectsById = _a.projectsById, sliderItems = _a.sliderItems, partnerItems = _a.partnerItems, projectItems = _a.projectItems, products = _a.products;
        var sliderElements = sliderItems.map(function (item) {
            var project = projectsById[item.projectId] || sample_1.default(projectsById);
            var image = project.images[item.imageId].url;
            return (react_1.default.createElement("div", { className: "slider__item", "aria-roledescription": "slide" },
                react_1.default.createElement("div", { className: "slider__image-container" },
                    react_1.default.createElement("div", { className: "slider__image", style: {
                            backgroundImage: "url(" + image + ")",
                        } }),
                    react_1.default.createElement(SliderDetails_1.SliderDetails, { title: project.title, content: react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: project.description } }) })),
                item.text && (react_1.default.createElement("article", { className: "slider__text", dangerouslySetInnerHTML: { __html: item.text } }))));
        });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "section section_no-padding" },
                react_1.default.createElement("div", { className: "slider" },
                    react_1.default.createElement(react_slick_1.default, tslib_1.__assign({ ref: function (component) { return (_this.sliderComponent = component); } }, {
                        adaptiveHeight: true,
                        dots: true,
                        infinite: true,
                        speed: 500,
                        pauseOnHover: true,
                        autoplay: true,
                        autoplaySpeed: 5000,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        customPaging: function (i) {
                            var project = projectsById[sliderItems[i].projectId] ||
                                sample_1.default(projectsById);
                            return react_1.default.createElement("div", { className: "slider__dot", title: project.title });
                        },
                    }), sliderElements.map(function (item, index) {
                        return (react_1.default.createElement("div", { key: index, className: "slider__item-wrapper" }, item));
                    })),
                    react_1.default.createElement("div", { className: "slider__arrows" },
                        react_1.default.createElement("button", { type: "button", className: "slider__arrow", onClick: this.previousSlide }),
                        react_1.default.createElement("button", { type: "button", className: "slider__arrow", onClick: this.nextSlide })))),
            react_1.default.createElement("div", { className: "main-section" },
                react_1.default.createElement("h2", { className: "main-section__title" }, "\u041D\u0430\u0448\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u044B"),
                react_1.default.createElement("div", { className: "main-partners" },
                    react_1.default.createElement("div", { className: "main-partners__list" },
                        react_1.default.createElement(ParnersBlock_1.PartnersBlock, { items: partnerItems })))),
            react_1.default.createElement("div", { className: "section section_no-padding" },
                react_1.default.createElement("div", { className: "wrapper wrapper_big" },
                    react_1.default.createElement("div", { className: "main-section" },
                        react_1.default.createElement("h2", { className: "main-section__title" }, "\u041D\u0430\u0448\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u044B"),
                        react_1.default.createElement(ProjectsBlock_1.ProjectsBlock, { items: projectItems })))),
            react_1.default.createElement("div", { className: "section section_no-padding section_grey" },
                react_1.default.createElement("div", { className: "wrapper wrapper_big" },
                    react_1.default.createElement("div", { className: "main-section" },
                        react_1.default.createElement("h2", { className: "main-section__title" }, "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u044B\u0435 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u044B"),
                        react_1.default.createElement(ProductsGrid_1.ProductsGrid, { items: products })))),
            react_1.default.createElement(ClaimForm_1.ClaimFormSection, null)));
    };
    MainPage = tslib_1.__decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], MainPage);
    return MainPage;
}(react_1.default.Component));
exports.MainPage = MainPage;
